import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "non-form-errors"
}
const _hoisted_2 = {
  key: 0,
  class: "help"
}
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "table is-hoverable is-fullwidth" }
const _hoisted_5 = { class: "has-background-grey-darker" }
const _hoisted_6 = {
  key: 0,
  scope: "col"
}
const _hoisted_7 = {
  key: 1,
  scope: "col"
}
const _hoisted_8 = {
  class: "field",
  style: {"display":"flex","align-items":"center","gap":"10px","margin-top":"15px"}
}
const _hoisted_9 = { class: "button is-static" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YieldRow = _resolveComponent("YieldRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.apiErrors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ('non_field_errors' in _ctx.apiErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiErrors['non_form_errors'], (error, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `non-form-error-${index}`
                    }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", _hoisted_5, [
          _createElementVNode("tr", null, [
            _cache[3] || (_cache[3] = _createElementVNode("th", { scope: "col" }, "Product", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("th", { scope: "col" }, "Price", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("th", { scope: "col" }, "Ratio", -1)),
            (_ctx.results.yields.length)
              ? (_openBlock(), _createElementBlock("th", _hoisted_6, "Leg"))
              : _createCommentVNode("", true),
            (_ctx.results.yields.length)
              ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Weighted"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formset, (values, index) => {
            return (_openBlock(), _createBlock(_component_YieldRow, {
              key: `yield-row-${index}`,
              rowId: index,
              products: _ctx.products,
              values: values,
              apiErrors: _ctx.apiErrors,
              result: _ctx.results.yields[index],
              showAdjustColumn: false,
              onRowUpdate: _ctx.rowUpdate
            }, null, 8, ["rowId", "products", "values", "apiErrors", "result", "onRowUpdate"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.calculateYield && _ctx.calculateYield(...args))),
        type: "button",
        class: "button is-outlined is-info"
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("span", { class: "icon" }, [
          _createElementVNode("i", {
            "aria-hidden": "true",
            class: "fas fa-calculator"
          })
        ], -1),
        _createElementVNode("span", null, " Calculate ", -1)
      ]))]),
      _createElementVNode("span", _hoisted_9, "Current Total: " + _toDisplayString(_ctx.results.total ? _ctx.results.total.toFixed(3) : '0'), 1),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyCurrentTotal && _ctx.copyCurrentTotal(...args))),
        type: "button",
        class: "button is-outlined is-light",
        title: "Copy to clipboard"
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("span", { class: "icon" }, [
          _createElementVNode("i", {
            "aria-hidden": "true",
            class: "fas fa-copy"
          })
        ], -1)
      ]))]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.initRows && _ctx.initRows(...args))),
        type: "button",
        class: "button is-outlined is-danger"
      }, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("span", { class: "icon" }, [
          _createElementVNode("i", {
            "aria-hidden": "true",
            class: "fas fa-trash-alt"
          })
        ], -1),
        _createElementVNode("span", null, " Clear ", -1)
      ]))])
    ])
  ]))
}